import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  loginUser,
  signUpUser,
  getProdcastById,
  getAllEvents,
  getEventsById,
  getDailyQuoteById,
  getUserDetailsById,
  getSignedUrlApi,
  createUserClicksApi1,
  getAllPriceLineFeedsApi,
  getAllYahooFeedsApi,
  getAllPricelineSales,
  changePasswordAPi,
} from "./authService";

export interface AuthState {
  loading: boolean;
  user: any;
  error: any;
  signUpResponse: any;
  allProdCasts: any;
  allEvents: any;
  dailyQuoteDetails: any;
  yahoologininfo: any;
  allPriceLineFeedsData: any;
  allYahooFeedsData: any;
  allPriceLineSales: any;
  userInfo: any;
}
const userData: string | null = localStorage.getItem("user");
const initialState: AuthState = {
  loading: false,
  user: userData !== null ? JSON.parse(userData) : {},
  error: null,
  signUpResponse: {},
  allProdCasts: {},
  allEvents: {},
  dailyQuoteDetails: {},
  yahoologininfo: {},
  allPriceLineFeedsData: {},
  allYahooFeedsData: {},
  allPriceLineSales: {},
  userInfo: {},
};

export const authSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setLoading: (state: AuthState, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    updateUserDetails: (state: AuthState, action: PayloadAction<any>) => {
      state.user = action.payload;
    },
    clearUserData: (state: AuthState, action: PayloadAction<any>) => {
      state.user = null;
    },
    updateErrorMessage: (state: AuthState, action: PayloadAction<boolean>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder: any) => {
    builder.addCase(loginUser.pending, (state: any) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      loginUser.fulfilled,
      (state: AuthState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        if (action?.payload?.user?._id) {
          state.user = action.payload?.user;
          var userInfo = action.payload?.user;
          localStorage.setItem("token", action.payload?.token);
          localStorage.setItem("user", JSON.stringify(userInfo));
        }
        // console.log("action", action);
      }
    );
    builder.addCase(loginUser.rejected, (state: AuthState, action: any) => {
      state.loading = false;
      // console.log("action", action);
      state.user = {};
      state.error = action.error?.message ?? "Something went wrong";
    });

    builder.addCase(signUpUser.pending, (state: any) => {
      state.loading = true;
      state.error = null;
      state.signUpResponse = null;
    });
    builder.addCase(
      signUpUser.fulfilled,
      (state: AuthState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        var userInfo = action.payload?.user;
        if (userInfo) {
          state.signUpResponse = action.payload;
          // state.user = userInfo;
          localStorage.setItem("token", action.payload?.token);
          // localStorage.setItem("user", JSON.stringify(userInfo));
        }
      }
    );
    builder.addCase(signUpUser.rejected, (state: AuthState, action: any) => {
      console.log({ action });
      state.loading = false;
      state.signUpResponse = null;
      state.error = action.error?.message ?? "Something went wrong";
    });
    builder.addCase(getProdcastById.pending, (state: any) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      getProdcastById.fulfilled,
      (state: AuthState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.allProdCasts = action.payload;
      }
    );
    builder.addCase(
      getProdcastById.rejected,
      (state: AuthState, action: any) => {
        console.log({ action });
        state.loading = false;
        state.error = action.error?.message ?? "Something went wrong";
      }
    );
    builder.addCase(getAllEvents.pending, (state: any) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      getAllEvents.fulfilled,
      (state: AuthState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.allEvents = action.payload;
      }
    );
    builder.addCase(getAllEvents.rejected, (state: AuthState, action: any) => {
      console.log({ action });
      state.loading = false;
      state.error = action.error?.message ?? "Something went wrong";
    });
    //getEventsById
    builder.addCase(getEventsById.pending, (state: any) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      getEventsById.fulfilled,
      (state: AuthState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.allEvents = action.payload;
      }
    );
    builder.addCase(getEventsById.rejected, (state: AuthState, action: any) => {
      console.log({ action });
      state.loading = false;
      state.error = action.error?.message ?? "Something went wrong";
    });
    //getDailyQuoteById
    builder.addCase(getDailyQuoteById.pending, (state: any) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      getDailyQuoteById.fulfilled,
      (state: AuthState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.dailyQuoteDetails = action.payload;
      }
    );
    builder.addCase(
      getDailyQuoteById.rejected,
      (state: AuthState, action: any) => {
        console.log({ action });
        state.loading = false;
        state.error = action.error?.message ?? "Something went wrong";
      }
    );
    //getUserDetailsById
    builder.addCase(getUserDetailsById.pending, (state: any) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      getUserDetailsById.fulfilled,
      (state: AuthState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.user = action.payload?.data;
        var userInfo = action.payload?.data;
        localStorage.setItem("user", JSON.stringify(userInfo));
      }
    );
    builder.addCase(
      getUserDetailsById.rejected,
      (state: AuthState, action: any) => {
        console.log({ action });
        state.loading = false;
        state.error = action.error?.message ?? "Something went wrong";
      }
    );
    //createUserClicksApi1
    builder.addCase(createUserClicksApi1.pending, (state: any) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      createUserClicksApi1.fulfilled,
      (state: AuthState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.yahoologininfo = action.payload;
        var userInfo = action.payload;
        localStorage.setItem("user", JSON.stringify(userInfo));
      }
    );
    builder.addCase(
      createUserClicksApi1.rejected,
      (state: AuthState, action: any) => {
        console.log({ action });
        state.loading = false;
        state.error = action.error?.message ?? "Something went wrong";
      }
    );
    //
    builder.addCase(getAllPriceLineFeedsApi.pending, (state: any) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      getAllPriceLineFeedsApi.fulfilled,
      (state: AuthState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.allPriceLineFeedsData = action.payload;
      }
    );
    builder.addCase(
      getAllPriceLineFeedsApi.rejected,
      (state: AuthState, action: any) => {
        state.loading = false;
      }
    );
    builder.addCase(getAllYahooFeedsApi.pending, (state: any) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      getAllYahooFeedsApi.fulfilled,
      (state: AuthState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.allYahooFeedsData = action.payload;
      }
    );
    builder.addCase(
      getAllYahooFeedsApi.rejected,
      (state: AuthState, action: any) => {
        state.loading = false;
      }
    );
    //getSignedUrlApi

    //getAllPricelineSales
    builder.addCase(getAllPricelineSales.pending, (state: any) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      getAllPricelineSales.fulfilled,
      (state: AuthState, action: PayloadAction<any>) => {
        state.error = null;
        state.loading = false;
        state.allPriceLineSales = action.payload;
      }
    );
    builder.addCase(
      getAllPricelineSales.rejected,
      (state: AuthState, action: any) => {
        state.loading = false;
      }
    );

    // PAssword Change

    builder.addCase(
      changePasswordAPi.pending,
      (state: AuthState, action: any) => {
        state.loading = true;
      }
    );

    builder.addCase(
      changePasswordAPi.rejected,
      (state: AuthState, action: any) => {
        state.loading = false;
      }
    );

    builder.addCase(
      changePasswordAPi.fulfilled,
      (state: AuthState, action: any) => {
        state.loading = false;
      }
    );
  },
});

export const {
  setLoading,
  updateUserDetails,
  updateErrorMessage,
  clearUserData,
} = authSlice.actions;

export default authSlice.reducer;
